function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459,131.83C432.43,81.13,382,46,327.71,32.69,275.88,20,213.48,20.62,174.47,62.43c-25.69,27.53-36,65.86-58.65,95.59-11.27,14.78-25.37,21.54-40.14,31.88C39.7,215.11,13.23,255.68,19,301.56c9.7,76.71,79.68,117.91,150,122.54,92.94,6.11,159.22-6.31,215.52-42.29,29.25-18.69,58.41-40.87,76.26-71.56,27-46.41,25.89-104.95,8.43-154.78A178.75,178.75,0,0,0,459,131.83Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459,131.83C432.43,81.13,382,46,327.71,32.69,275.88,20,213.48,20.62,174.47,62.43c-25.69,27.53-36,65.86-58.65,95.59-11.27,14.78-25.37,21.54-40.14,31.88C39.7,215.11,13.23,255.68,19,301.56c9.7,76.71,79.68,117.91,150,122.54,92.94,6.11,159.22-6.31,215.52-42.29,29.25-18.69,58.41-40.87,76.26-71.56,27-46.41,25.89-104.95,8.43-154.78A178.75,178.75,0,0,0,459,131.83Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Signs--inject-36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.1,468.8h-9.55V53.34a4.77,4.77,0,0,1,4.77-4.77h0a4.77,4.77,0,0,1,4.78,4.77Z",
    style: {
      fill: "#99246A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.59,
    y: 103.91,
    width: 83.69,
    height: 29.47,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.26,
    y: 72.32,
    width: 83.69,
    height: 29.47,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.26 153.53 292.99 159.47 292.99 118.12 246.26 124.06 246.26 153.53",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.57 139.58 273.26 128.21 273.26 133.17 251.72 134.02 251.72 144.82 273.26 145.89 273.26 150.85 283.57 139.58",
    style: {
      fill: "#99246A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.19 84.91 301.29 75.73 301.29 79.75 259.36 79.75 259.36 90.07 301.29 90.07 301.29 94.1 317.19 84.91",
    style: {
      fill: "#99246A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.01 118.86 181.91 109.68 181.91 113.7 223.84 113.7 223.84 124.02 181.91 124.02 181.91 128.04 166.01 118.86",
    style: {
      fill: "#99246A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-36"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 371.34,
    cy: 98.8,
    r: 34.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.15,121.7a32.65,32.65,0,0,1-7.9,5.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.63,129.45a32.34,32.34,0,1,1,17.49-14.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.34,
    cy: 98.8,
    r: 2.56,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "375.02 113.17 371.34 98.8 392.82 84.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "143.45 188.78 143.45 240.01 105.29 240.01",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "73.98 231.97 73.98 174.8 143.45 174.8 143.45 184.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "99.81 240.01 73.98 240.01 73.98 235.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.21,
    y: 190.85,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.25,
    y: 190.85,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.29,
    y: 190.85,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.33,
    y: 190.85,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.37,
    y: 190.85,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.41,
    y: 190.85,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.45,
    y: 190.85,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.21,
    y: 201.55,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.25,
    y: 201.55,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.29,
    y: 201.55,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.33,
    y: 201.55,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.37,
    y: 201.55,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.41,
    y: 201.55,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.45,
    y: 201.55,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.21,
    y: 212.25,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.25,
    y: 212.25,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.29,
    y: 212.25,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.33,
    y: 212.25,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.37,
    y: 212.25,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.41,
    y: 212.25,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.45,
    y: 212.25,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.21,
    y: 222.95,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.25,
    y: 222.95,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.29,
    y: 222.95,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.33,
    y: 222.95,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.37,
    y: 222.95,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.41,
    y: 222.95,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.45,
    y: 222.95,
    width: 6.78,
    height: 6.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.27,179.41h-3v-11h3Zm12-11h-3v11h3Zm12,0h-3v11h3Zm12,0h-3v11h3Zm12,0h-3v11h3Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.72,283.85a26.5,26.5,0,1,0,26.49,26.5A26.49,26.49,0,0,0,108.72,283.85Zm0,43.26a16.77,16.77,0,1,1,16.76-16.76A16.77,16.77,0,0,1,108.72,327.11Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.26,283.86v9.75a16.74,16.74,0,0,1,11.38,28.51l7.65,6.08a26.49,26.49,0,0,0-19-44.34Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.98,
    y1: 309.26,
    x2: 117.91,
    y2: 309.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.98,
    y1: 314.13,
    x2: 117.91,
    y2: 314.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 349.07,
    y1: 191.41,
    x2: 400.62,
    y2: 191.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 328.53,
    y1: 191.41,
    x2: 333.83,
    y2: 191.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 366.24,
    y1: 199.59,
    x2: 400.62,
    y2: 199.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 328.53,
    y1: 199.59,
    x2: 334.25,
    y2: 199.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382.77,
    y1: 207.77,
    x2: 400.62,
    y2: 207.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 328.53,
    y1: 207.77,
    x2: 333.83,
    y2: 207.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 397.43,
    y1: 215.94,
    x2: 400.62,
    y2: 215.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 328.53,
    y1: 215.94,
    x2: 333.83,
    y2: 215.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 397.43,
    y1: 225.46,
    x2: 400.62,
    y2: 225.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 328.53,
    y1: 225.46,
    x2: 333.83,
    y2: 225.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 397.43,
    y1: 234.98,
    x2: 400.62,
    y2: 234.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 328.53,
    y1: 234.98,
    x2: 333.83,
    y2: 234.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.19,
    y: 185.75,
    width: 11.95,
    height: 50.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.54,
    y: 195.18,
    width: 11.95,
    height: 40.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.9,
    y: 203.99,
    width: 11.95,
    height: 31.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.26,
    y: 215.32,
    width: 11.95,
    height: 20.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.26,73.37a29.46,29.46,0,1,0,3.94,3.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.89,110.37a19.27,19.27,0,1,0-2.28-2.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.72,
    cy: 96.92,
    r: 10.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.89,297.18c3.23.46,4.71,3,4.71,6.54v.73h-2.77v-.92c0-2.35-.95-3.8-3.08-3.8s-3.05,1.45-3.05,3.8c0,6,8.94,6,8.94,13.51,0,3.57-1.52,6.12-4.75,6.58v2h-2.44v-2c-3.31-.46-4.79-3-4.79-6.58V315.4h2.78v1.83c0,2.39,1,3.76,3.12,3.76s3.11-1.37,3.11-3.76c0-5.94-8.9-6-8.9-13.51,0-3.65,1.49-6,4.68-6.54v-2.13h2.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.38,332.86a24.27,24.27,0,0,0,5.25-3.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,287.39a24.54,24.54,0,0,0,13.65,47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.72,326.93a24.54,24.54,0,0,0-24.09-40.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.65,
    cy: 310.34,
    r: 20.11,
    transform: "translate(-114.03 329.79) rotate(-42.81)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266,221.56l.71-.08c3-.37,14.76-1.95,21.49-4.61,7.76-3.07,25.45-1.45,25.45-1.45l7.76,5.6-8.84,5.78s-12.46-4.16-21.12-3.8-12.81,2.89-18.23,2.53-12.09-4-12.09-4Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.81 204 232.81 215.61 251.95 215.61 251.95 202.17 232.81 204",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.58,192.73s-4.53-3-3,2.26,3,7.31,5.29,7.06,3.53-1,2.77-3S227.58,192.73,227.58,192.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.87,192.73s4.53-3,3,2.26-3,7.31-5.29,7.06-3.52-1-2.77-3S257.87,192.73,257.87,192.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.41,168.55s-7.56,2.51-10.08,9.57-.25,15.61,1,19.14,7.31,10.33,7.31,10.33h13.6a39.12,39.12,0,0,0,7.81-11.08c2.77-6.3,2.77-15.12,2.77-15.12s2.26.76,2.26-2.27-7-8.81-7-8.81,3.28-1.26,1-3-10.33-1-10.33-1S244.71,161,237.41,168.55Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.21,457.94l2.07,1.29a5.84,5.84,0,0,1,3.62,1.29c1.29,1.3.81,7.72.81,7.72s-1,.76-5.95.76S252,470.2,251,468.39s.18-9.42.18-9.42Z",
    style: {
      fill: "#858585",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.57,295.27S209,306.65,209,309s-.52,22.5-.52,22.5.26,53,.26,54-4.4,15.52-2.84,25.35,4.65,47.58,4.65,47.58-1,8.28-.26,9.05,10.35,1.81,12.42.78.77-11.12.77-11.12a33.29,33.29,0,0,0,1.3-7.5v-8.28c0-2.58,1.29-25.6,2.58-34.65s2.07-21.21,2.07-21.21l5.43-55.86,4.14-.26s5.17,60,5.43,64.4S243.67,407,246,417.07s3.62,37.5,3.62,37.5-.52,2.59,0,3.62,1.81,4.14,1.81,4.14a29.74,29.74,0,0,0,5.43,0,20.08,20.08,0,0,0,8.32-2.26,5.59,5.59,0,0,0,1.68-6.42c-1.55-3.79-2.24-4.51-2.24-4.51s2.33-32.58,2.33-40.6-1.29-17.84-1.29-18.62,1.55-59,1.55-64.91-.52-22-3.11-29-44-5.17-48.1-4.91A6.34,6.34,0,0,0,210.57,295.27Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 225.83,
    y1: 329.27,
    x2: 248.07,
    y2: 328.24,
    style: {
      fill: "none",
      stroke: "#757575",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.76,215.1l-14,3.36s-20.18,9.83-24.57,12.41-21.73,37.5-20.95,39.31,4.14,4.14,7.5,4.66S207.21,256,207.21,256s4.91,24.31,4.91,25.34-2.84,13.45-1.55,15.52,50.95,0,50.95,0,3.62.26,4.14-3.1-1-13.19-1-13.19l5.69-29.74s10.87,16.48,13.31,19.13c4.23,4.61,9.49,2.68,12.29-.77,2.45-3,.26-8.8-.51-10.61S280.91,226,276.78,224.67s-21.47-7.5-21.47-7.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.8,218.46s17.09-.35,19.93-.35S258,218,258,218l-2.63-5.6a54.47,54.47,0,0,0-13.7-1.56,41.32,41.32,0,0,0-14.48,2.59Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "201.95 242.32 207.21 255.96 198.16 246.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.23,
    y1: 237.85,
    x2: 200.85,
    y2: 239.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.33,279.05a25.8,25.8,0,0,1-2.72,2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,239.92s-9.45,25.85-22.11,37.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "276.26 236.04 270.31 250.79 279.88 240.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,276.65a23,23,0,0,0,7.5,10.34c5.69,4.4,21,18.88,21,18.88a5.81,5.81,0,0,0,0,2.33c.26,1.29,4.4,4.65,4.4,4.65v-2.58l1-2.07,1-2.59a30.24,30.24,0,0,0,3.37-1.55,5.44,5.44,0,0,0,1.29-1.29,33.93,33.93,0,0,0,4.65.51c1.81,0,4.4-1.81,2.85-2.32s-3.1,0-5.17-1-3.11-2.07-5.18-2.07h-5.43L194,274.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.07,260.75s-3,.9-3.79,1.67-4.66,6.73-3.88,9.83,1.81,7.5,8.53,8.79,10.35-1.55,10.87-2.32,1.79-9.93.75-9.93-3.86,3.46-3.86,3.46-7.7-1.74-9.25-3S183.07,260.75,183.07,260.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.72,276.65a23,23,0,0,1-7.5,10.34c-5.69,4.4-21,18.88-21,18.88a5.81,5.81,0,0,1,0,2.33c-.26,1.29-5.95,5.27-5.95,5.27V309.7l-.4-2.38-.11-1.71a30.24,30.24,0,0,1-3.37-1.55,5.44,5.44,0,0,1-1.29-1.29,33.93,33.93,0,0,1-4.65.51c-1.81,0-4.4-1.81-2.85-2.32s3.1,0,5.17-1,3.11-2.07,5.18-2.07h5.43l14.22-23.27Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.68,262s1.94-.37,2.71.4,4.66,6.73,3.88,9.83-1.81,7.5-8.53,8.79-10.35-1.55-10.87-2.32-.93-9.58-.25-8.8a10.7,10.7,0,0,0,3.36,2.33s8-.41,9.27-4.94A22.83,22.83,0,0,0,296.68,262Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.73,468.28c1.63-.82,1.17-7.27.9-9.95a19.06,19.06,0,0,1-5.82,1.67,10.88,10.88,0,0,1-7.24-1.55s-.83,8.95-.13,9.79S220.66,469.31,222.73,468.28Z",
    style: {
      fill: "#858585",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401,469.33a.4.4,0,0,1-.4-.4V417.35a.4.4,0,1,1,.8,0v51.58A.4.4,0,0,1,401,469.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.6,464.28a22,22,0,0,0-6.21-5.82c-3.49-1.94-9.3-1.94-9.3-1.94S388.19,467.77,400.6,464.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,464.28a22.09,22.09,0,0,1,6.2-5.82c3.49-1.94,9.31-1.94,9.31-1.94S413.4,467.77,401,464.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.6,450.32a22,22,0,0,0-6.21-5.82c-3.49-1.94-9.3-1.94-9.3-1.94S388.19,453.81,400.6,450.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,450.32a22.09,22.09,0,0,1,6.2-5.82c3.49-1.94,9.31-1.94,9.31-1.94S413.4,453.81,401,450.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.6,436.35a21.92,21.92,0,0,0-6.21-5.81c-3.49-1.94-9.3-1.94-9.3-1.94S388.19,439.84,400.6,436.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,436.35a22,22,0,0,1,6.2-5.81c3.49-1.94,9.31-1.94,9.31-1.94S413.4,439.84,401,436.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.6,422.39a22,22,0,0,0-6.21-5.82c-3.49-1.94-9.3-1.94-9.3-1.94S388.19,425.88,400.6,422.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,422.39a22.09,22.09,0,0,1,6.2-5.82c3.49-1.94,9.31-1.94,9.31-1.94S413.4,425.88,401,422.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,417.35s-3.11-4.18-3.26-8.17,2.46-9.18,2.46-9.18S409.7,407.85,401,417.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.19,469.33a.43.43,0,0,1-.43-.43V413.14a.43.43,0,0,1,.86,0V468.9A.43.43,0,0,1,59.19,469.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.77,463.87a23.89,23.89,0,0,0-6.71-6.29c-3.77-2.1-10.06-2.1-10.06-2.1S45.35,467.64,58.77,463.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.19,463.87a23.89,23.89,0,0,1,6.71-6.29c3.77-2.1,10.06-2.1,10.06-2.1S72.6,467.64,59.19,463.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.77,448.78a23.74,23.74,0,0,0-6.71-6.29c-3.77-2.1-10.06-2.1-10.06-2.1S45.35,452.55,58.77,448.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.19,448.78a23.74,23.74,0,0,1,6.71-6.29c3.77-2.1,10.06-2.1,10.06-2.1S72.6,452.55,59.19,448.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.77,433.68a23.89,23.89,0,0,0-6.71-6.29C48.29,425.3,42,425.3,42,425.3S45.35,437.46,58.77,433.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.19,433.68a23.89,23.89,0,0,1,6.71-6.29C69.67,425.3,76,425.3,76,425.3S72.6,437.46,59.19,433.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.77,418.59a23.89,23.89,0,0,0-6.71-6.29C48.29,410.21,42,410.21,42,410.21S45.35,422.36,58.77,418.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.19,418.59a23.89,23.89,0,0,1,6.71-6.29c3.77-2.09,10.06-2.09,10.06-2.09S72.6,422.36,59.19,418.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.19,413.14s-3.36-4.51-3.53-8.83,2.67-9.92,2.67-9.92S68.61,402.87,59.19,413.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.22,469.08V443.72a.43.43,0,1,0-.86,0v25.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.37,464.26A23.89,23.89,0,0,0,87.66,458c-3.77-2.09-10.06-2.09-10.06-2.09S81,468,94.37,464.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.79,464.26A23.89,23.89,0,0,1,101.5,458c3.77-2.09,10.06-2.09,10.06-2.09S108.21,468,94.79,464.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.37,449.17a23.89,23.89,0,0,0-6.71-6.29c-3.77-2.1-10.06-2.1-10.06-2.1S81,452.94,94.37,449.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.79,449.17a23.89,23.89,0,0,1,6.71-6.29c3.77-2.1,10.06-2.1,10.06-2.1S108.21,452.94,94.79,449.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.79,443.72s-3.36-4.51-3.52-8.83S93.93,425,93.93,425,104.21,433.45,94.79,443.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.93,469.1V445.64a.4.4,0,0,0-.8,0V469.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.14,464.64a22.09,22.09,0,0,0-6.2-5.82c-3.49-1.94-9.31-1.94-9.31-1.94S353.73,468.13,366.14,464.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.53,464.64a22,22,0,0,1,6.21-5.82c3.49-1.94,9.3-1.94,9.3-1.94S378.94,468.13,366.53,464.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.14,450.68a22.09,22.09,0,0,0-6.2-5.82c-3.49-1.94-9.31-1.94-9.31-1.94S353.73,454.17,366.14,450.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.53,450.68a22,22,0,0,1,6.21-5.82c3.49-1.94,9.3-1.94,9.3-1.94S378.94,454.17,366.53,450.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.53,445.64s-3.1-4.18-3.26-8.17,2.47-9.18,2.47-9.18S375.24,436.13,366.53,445.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.47,469.1V445.64a.4.4,0,0,0-.8,0V469.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.68,464.64a22.09,22.09,0,0,0-6.2-5.82c-3.49-1.94-9.31-1.94-9.31-1.94S421.27,468.13,433.68,464.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.07,464.64a22.2,22.2,0,0,1,6.21-5.82c3.49-1.94,9.31-1.94,9.31-1.94S446.48,468.13,434.07,464.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.68,450.68a22.09,22.09,0,0,0-6.2-5.82c-3.49-1.94-9.31-1.94-9.31-1.94S421.27,454.17,433.68,450.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.07,450.68a22.2,22.2,0,0,1,6.21-5.82c3.49-1.94,9.31-1.94,9.31-1.94S446.48,454.17,434.07,450.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.07,445.64s-3.1-4.18-3.26-8.17,2.47-9.18,2.47-9.18S442.78,436.13,434.07,445.64Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-36"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 475.24,
    y1: 469,
    x2: 482,
    y2: 469,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 117.89,
    y1: 469,
    x2: 466.01,
    y2: 469,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 469,
    x2: 108.66,
    y2: 469,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.d9cb73bfeb03855f0a908b58df775be9.svg";
export { ForwardRef as ReactComponent };